// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"DownloadButton_downloadButton__2kMRD","icon":"DownloadButton_icon__37H8v","baseline":"DownloadButton_baseline__34tV0"};